import { BackendLocationModel } from './location.model';
import {Vehicle} from './vehicle';
import {DriverModel} from './driver.model';

export class VehicleBreadcrumb {
  constructor(readonly time: Date,
              readonly vehicle: Vehicle,
              readonly driver: DriverModel,
              readonly location: BackendLocationModel,
              readonly shiftId: number,
              readonly imageUrl: string|null,
  ) {}
}

export class VehicleBreadcrumbUpdate {
  constructor(readonly breadcrumbs: Array<VehicleBreadcrumb>|null,
              readonly source: string) {}
}

export class VehicleLocationUpdate {

  constructor(readonly vehicleId: number,
              readonly time: Date,
              readonly location?: BackendLocationModel,
  ) {}
}
